import type { LibraryCategory } from "@/api/models"

/**
 * Filter categories by the search box value.
 *
 * The query is trimmed once and the trimmed value is what gets matched, so a
 * stray leading or trailing space (common when pasting) no longer turns a
 * matching search such as " avtal " into an empty result list.
 */
export function filterCategoriesByQuery(
  categories: LibraryCategory[],
  searchQuery: string
): LibraryCategory[] {
  const query = searchQuery.trim().toLowerCase()
  if (!query) {
    return categories
  }
  return categories.filter((category) => category.value.toLowerCase().includes(query))
}
